/* eslint-disable no-param-reassign */

const validateFields = (field, formState, form) => {
  switch (field) {
    case "from": if (!formState.from) { form.from = "Required"; } break;
    case "to": if (!formState.to) { form.to = "Required"; } if (formState.from && formState.from > formState.to) { form.to = "From date should be less than To date"; } break;
    case "checkedVehicles": if (formState.checkedVehicles && formState.checkedVehicles.length === 0) {
      form.checkedVehicles = "Required";
    }
      break;
    default:
      break;
  }
};
const validateContract = (formState) => {
  const form = {};
  if (formState.isNextClicked) {
    Object.entries(formState).forEach(([key]) => {
      validateFields(key, formState, form);
    });
  }
  return form;
};

export default validateContract;
